(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['response.hbs'] = template({"1":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression, buffer = "  <div class=\"response-status\">\n    HTTP/1.1 "
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.res : depth0)) != null ? stack1.status : stack1), depth0))
    + " "
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.$res : depth0)) != null ? stack1.statusText : stack1), depth0))
    + "\n  </div>\n  <div class=\"response-headers\">\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.responseHeaders : depth0), {"name":"each","hash":{},"fn":this.program(2, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  </div>\n";
},"2":function(depth0,helpers,partials,data) {
  var lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "    <div class=\"response-header\">\n      <span class=\"response-header-name\">"
    + escapeExpression(lambda((depth0 != null ? depth0.name : depth0), depth0))
    + ":</span>\n      <span class=\"response-header-value\">"
    + escapeExpression(lambda((depth0 != null ? depth0.value : depth0), depth0))
    + "</span>\n    </div>\n";
},"4":function(depth0,helpers,partials,data) {
  return "  <i>Response headers not available.</i><br/>\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.res : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.program(4, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "<br/>\n<div id=\"response-body\" class=\"response-body\"></div>\n";
},"useData":true});
})();
